import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

const { foundations } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  closeButton: {
    marginLeft: '8px',
    '& .MuiSvgIcon-root': {
      marginRight: '0px',
    },
  },
  dialogContent: {
    paddingTop: '16px',
  },
  textField: {
    width: '100%',
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      margin: 0,
      width: '100%',
    },
  },
  labelRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '4px',
  },
  formLabel: {
    fontSize: '16px',
    fontWeight: foundations.typography.fontWeight.medium,
  },
  characterCounter: {},
  listItem: {
    marginTop: '16px'
  },
  dialogActions: {
    justifyContent: 'flex-end',
    gap: '8px',
    padding: '16px 24px'
  }
});
